import React, { useState } from "react";

export default function AnugyaStartJourney() {

  const [mode, setMode] = useState("individual");
  const [current, setCurrent] = useState(0);

  const flows = {

    individual: [
      {
        title: "Create Demo Identity",
        desc: "Start your sandbox experience instantly",
        route: "/demo/signup",
        icon: "fa-user-plus"
      },
      {
        title: "Explore Dashboard",
        desc: "Understand consent & system overview",
        route: "/app/dashboard",
        icon: "fa-chart-line"
      },
      {
        title: "Upload Document",
        desc: "Simulate real document ingestion",
        route: "/app/upload",
        icon: "fa-file-arrow-up"
      },
      {
        title: "Execute Consent Flow",
        desc: "Trigger real-time governance logic",
        route: "/app/consent",
        icon: "fa-shield-halved"
      },
      {
        title: "View Audit Logs",
        desc: "See full traceability & transparency",
        route: "/app/audit",
        icon: "fa-clipboard-list"
      }
    ],

    bfsi: [
      {
        title: "Customer Loan Upload",
        desc: "Customer submits loan documents securely",
        route: "/bfsi/upload",
        icon: "fa-file-contract"
      },
      {
        title: "Consent Request Initiated",
        desc: "Bank triggers consent workflow",
        route: "/bfsi/consent-request",
        icon: "fa-unlock-keyhole"
      },
      {
        title: "AI Risk & Fraud Check",
        desc: "System evaluates document authenticity",
        route: "/bfsi/ai-signal",
        icon: "fa-brain"
      },
      {
        title: "Temporary Access Granted",
        desc: "Time-bound controlled access issued",
        route: "/bfsi/access-control",
        icon: "fa-clock"
      },
      {
        title: "Loan Processing Usage",
        desc: "Document used for verification workflow",
        route: "/bfsi/processing",
        icon: "fa-building-columns"
      },
      {
        title: "Audit Trail Generated",
        desc: "Full compliance record created",
        route: "/bfsi/audit",
        icon: "fa-clipboard-check"
      }
    ],

    institutional: [
      {
        title: "Department Document Upload",
        desc: "Enterprise data ingestion begins",
        route: "/inst/upload",
        icon: "fa-building"
      },
      {
        title: "Policy Enforcement Layer",
        desc: "Access rules applied automatically",
        route: "/inst/policy",
        icon: "fa-shield"
      },
      {
        title: "Approval Workflow Trigger",
        desc: "Multi-level approvals activated",
        route: "/inst/approval",
        icon: "fa-sitemap"
      },
      {
        title: "Controlled Data Sharing",
        desc: "Cross-team secure access",
        route: "/inst/sharing",
        icon: "fa-share-nodes"
      },
      {
        title: "AI Usage Tracking",
        desc: "System-level monitoring enabled",
        route: "/inst/ai-tracking",
        icon: "fa-microchip"
      },
      {
        title: "Compliance Audit Report",
        desc: "Enterprise-grade governance log",
        route: "/inst/audit",
        icon: "fa-file-shield"
      }
    ]
  };

  const steps = flows[mode];
  const step = steps[current];

  const changeMode = (m) => {
    setMode(m);
    setCurrent(0);
  };

  return (
    <div className="p-4 bg-slate-900 rounded-2xl text-white space-y-4">

      {/* HEADER */}
      <div>
        <h2 className="text-xl font-bold flex items-center gap-2 text-yellow-200">
          <i className="fa-solid fa-rocket text-blue-400"></i>
          Guided Anugya Journey
        </h2>

        <p className="text-sm text-slate-100 mt-1">
          Multi-context workflow simulation engine
        </p>

        {/* MODE SWITCH (UNCHANGED STYLE) */}
        <div className="grid grid-cols-3 gap-2 mt-3">
          <button
            onClick={() => changeMode("individual")}
            className={`p-2 text-xs lg:text-sm rounded-xl ${
              mode === "individual"
                ? "bg-blue-600"
                : "bg-slate-700"
            }`}
          >
            Individual
          </button>

          <button
            onClick={() => changeMode("bfsi")}
            className={`p-2 text-xs lg:text-sm rounded-xl ${
              mode === "bfsi"
                ? "bg-indigo-600"
                : "bg-slate-700"
            }`}
          >
            BFSI
          </button>

          <button
            onClick={() => changeMode("institutional")}
            className={`p-2 text-xs lg:text-sm rounded-xl ${
              mode === "institutional"
                ? "bg-green-600"
                : "bg-slate-700"
            }`}
          >
            Institutional
          </button>
        </div>
      </div>

      {/* PROGRESS BAR */}
      <div className="w-full bg-slate-700 h-2 rounded-full overflow-hidden">
        <div
          className="h-2 bg-blue-500 transition-all"
          style={{
            width: `${((current + 1) / steps.length) * 100}%`,
          }}
        />
      </div>

      {/* STEP CARD */}
      <div className="bg-slate-800 p-4 rounded-xl space-y-2">

        <div className="flex items-center gap-2">
          <i className={`fa-solid ${step.icon} text-blue-300`} />
          <p className="font-semibold text-cyan-200">{step.title}</p>
        </div>

        <p className="text-sm text-slate-100">{step.desc}</p>

        <p className="text-xs text-green-400">
          Preview Route: {step.route}
        </p>

      </div>

      {/* NAVIGATION */}
      <div className="flex gap-3">

        <button
          onClick={() => setCurrent((p) => Math.max(p - 1, 0))}
          className="flex-1 bg-slate-700 py-2 rounded-xl"
        >
          Back
        </button>

        <button
          onClick={() =>
            setCurrent((p) => Math.min(p + 1, steps.length - 1))
          }
          className="flex-1 bg-blue-600 py-2 rounded-xl font-semibold"
        >
          Next
        </button>

      </div>

      {/* CTA */}
      {current === steps.length - 1 && (
        <button className="w-full bg-green-600 py-3 rounded-xl font-semibold">
          🚀 Start Demo Account
        </button>
      )}
    </div>
  );
}